import { render, staticRenderFns } from "./DesktopTopBar.vue?vue&type=template&id=36f4969e&scoped=true"
import script from "./DesktopTopBar.vue?vue&type=script&lang=js"
export * from "./DesktopTopBar.vue?vue&type=script&lang=js"
import style0 from "./DesktopTopBar.vue?vue&type=style&index=0&id=36f4969e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f4969e",
  null
  
)

export default component.exports